import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
function load(apiKey) {
  return new Promise(function (resolve, reject) {
    try {
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
      } else {
        var url = '//maps.googleapis.com/maps/api/js';
        var params = {
          libraries: ['places'].join(','),
          key: apiKey,
          callback: Date.now()
        };
        window[params.callback] = function () {
          delete window[params.callback];
          resolve(window.google.maps);
        };
        document.body.appendChild(Object.assign(document.createElement('script'), {
          src: "".concat(url, "?").concat(Object.keys(params).map(function (key) {
            return [key, params[key]].join('=');
          }).join('&')),
          async: true,
          defer: true
        }));
      }
    } catch (error) {
      reject(error);
    }
  });
}
function Google(Component) {
  var _a;
  return _a = /*#__PURE__*/function (_React$Component) {
    function Google() {
      _classCallCheck(this, Google);
      return _callSuper(this, Google, arguments);
    }
    _inherits(Google, _React$Component);
    return _createClass(Google, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          api: this.api
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;
        load(this.props.apiKey).then(function (api) {
          _this.api = api;
          _this.forceUpdate();
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, Object.assign({}, this.props));
      }
    }]);
  }(React.Component), _a.childContextTypes = {
    api: PropTypes.object
  }, _a.propTypes = {
    apiKey: PropTypes.string
  }, _a;
}
export default Google;